import React from "react";
import Select from "react-select";
import { Boxes } from "lucide-react";

const ProductTypeSelect = ({
  options,
  value,
  onChange,
  isLoading,
  isDisabled,
}) => (
  <section className="feature-panel feature-panel--accent">
    <div className="feature-panel__header">
      <div className="feature-panel__icon">
        <Boxes size={22} />
      </div>
      <div>
        <h3>Product Type</h3>
        <p>Select a product type to load feature filters.</p>
      </div>
    </div>
    <Select
      classNamePrefix="feature-select"
      isClearable
      isSearchable
      isLoading={isLoading}
      isDisabled={isDisabled || isLoading}
      options={options}
      value={options.find((option) => option.value === value) || null}
      onChange={(option) => onChange(option?.value || "")}
      placeholder="Search product type"
      noOptionsMessage={() => "No product types found"}
    />
  </section>
);

export default ProductTypeSelect;
